import React from 'react';
import './DirectionButton.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';

export default function DirectionButton(props) {
    return (
        <motion.div
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => props.onClick()}
            styleName={`direction-button ${props?.active ? 'active' : ''}`}
        >
            <FontAwesomeIcon styleName="icon" icon={props.icon} />
            <p>{props.text}</p>
        </motion.div>
    );
}
